import { render } from "./ClientGrid.vue?vue&type=template&id=4763715b"
import script from "./ClientGrid.vue?vue&type=script&lang=js"
export * from "./ClientGrid.vue?vue&type=script&lang=js"

import "./ClientGrid.vue?vue&type=style&index=0&id=4763715b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__